export default "__VITE_ASSET__BUhgRGXK__"